import { Base } from "@tt-app/api/base";

class App extends Base {
  async gitInfo() {
    const url = `${window.location.origin}/GitInfo.json?queryTime=${Date.now()}`;

    return this.httpClient.get(url);
  }
}

export { App };
